import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { List } from "../../../core/models/list.model"
import { Day } from "../../../core/models/day.model"
import { Real } from "../../../core/models/real.model"
import { ProviderServiceService } from '../../../core/services/provider-service.service'
import { Router, ActivatedRoute } from '@angular/router';
import { IonSlides } from '@ionic/angular';

import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

import { TranslateService } from "@ngx-translate/core";

import { PpTranslatePipe } from '../../../shared/pipes/pp-translate.pipe';

@Component({
  selector: 'app-days-calendar',
  templateUrl: './days-calendar.component.html',
  styleUrls: ['./days-calendar.component.scss'],
})
export class DaysCalendarComponent implements OnInit {

  @Input() days$: Observable<List>;
  @Input() selectedDay: string;
  @Input() real: Real;
  @Output() onDaySelected = new EventEmitter<Day>();


  @ViewChild(IonSlides) slides: IonSlides;

  servicesSnapshot: {};

  loading = false;

  initialSlideIndex = 1;

  slideOpts = {


    initialSlide: 1,

    scrollbar: false,
    navigation: false,
    pagination: false,
    //slidesPerView: 11,
    //spaceBetween: 40,
    slidesPerGroup: 3,
    //paginationClickable: true,

    breakpoints: {
      1000: {
        slidesPerView: 8,
        spaceBetween: 10
      },
      500: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      359: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      319: {
        slidesPerView: 2,
        spaceBetween: 10
      }
    }

  };


  constructor( private route: ActivatedRoute, private ppTranslatePipe: PpTranslatePipe, public translateService: TranslateService, private providerServiceService: ProviderServiceService ) {
    this.providerServiceService.services$.subscribe( categories => {

      let servicesById = {};
      
      for( let category of categories ) {
        servicesById['id_' + category.id] = category;
      }

      this.servicesSnapshot = servicesById;
      console.log(this.servicesSnapshot);

    });  
  }

  getEventText( events, lang = 'sl' ) {
    
    let text = '';
    let exclusive = false;

    for( let e of events ) {

      let s = this.servicesSnapshot['id_' + e ];

      if ( s && s.specialOffer ) {

        /*if ( text && !exclusive && s.exclusiveEvent ) {
          text = this.ppTranslatePipe.transform(s.name, s.nameTranslations, lang);
          
        }*/
        
        if ('sl' !== lang && s.nameTranslations[lang] ) {
          text = s.nameTranslations[lang];
        } else {
          text = s.name;
        }
        //text = s.name; //this.ppTranslatePipe.transform(s.name, s.nameTranslations, lang);
      } 

    }

    return text;

  }

  ngOnInit() {
    this.initialSlideIndex = this.getInitialSlideIndex();
  }

  selectDay( day: Day ) {
    this.selectedDay = day.date;
    this.onDaySelected.emit( day );
  }

  getDayOfWeek( dateString, locale = 'en' ) {
    moment.locale( locale );
    return moment( dateString ).format('ddd').substr(0, 3);
  }

  getInitialSlideIndex() {


    let a = moment().startOf('day');

    console.log(a);

    if ( this.route.snapshot.queryParamMap.get('from') ) {

      let b = moment( this.route.snapshot.queryParamMap.get('from') );

      return b.diff(a, 'days');   // =1

    } else {

      return 0;
    }
    
    
  }


  goToInitialSlide() {

    if ( this.route.snapshot.queryParamMap.get('from') ) {
      let initial = this.getInitialSlideIndex();
      this.slides.slideTo(initial);
    }
    
  }

  getDayOfMonth( dateString, locale = 'en' ) {
    moment.locale( locale );
    return moment( dateString ).locale( locale ).format('D');
  }

  getMonth( dateString, locale = 'en' ) {
    moment.locale( locale );
    return moment( dateString ).format('MMMM');
  }

  getMonthAndYear( dateString, locale = 'en' ) {
    moment.locale( locale );
    return moment( dateString ).format('MMMM') + ' ' + moment( dateString ).format('Y');
  }

}
